import { RouteConfig } from 'vue-router';

const list: Array<RouteConfig> = [
  {
    path: 'networks/add',
    name: 'iframeNetworks',
    component: () => import('@/self-service/pages/iframe/iframeNetworksAdd'),
    meta: {
      title: $t => $t('Add network interface'),
      restrictions: {
        action: 'create',
        resource: 'compute_private_networks'
      },
    }
  },
  {
    path: 'networks/:networkId/edit-ipv4-subnet/:subnetId',
    name: 'computeNetworkEditIPv4Subnet',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeSubnetEdit'),
    meta: {
      title: $t => $t('Edit IPv4 subnet'),
      restrictions: {
        action: 'update',
        resource: 'compute_network_details'
      },
    }
  },
  {
    path: 'routers/add',
    name: 'routerCreate',
    component: () => import('@/self-service/pages/iframe/iframeVirtualRouterDialog'),
    meta: {
      title: $t => $t('Add virtual router'),
      restrictions: {
        action: 'create',
        resource: 'compute_routers'
      },
    }
  },
  {
    path: 'routers/:routerId/edit',
    name: 'iframeRouterEdit',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeVirtualRouterDialog'),
    meta: {
      title: $t => $t('Rename virtual router'),
      restrictions: {
        action: 'update',
        resource: 'compute_routers_router'
      }
    }
  },
  {
    path: 'routers/:routerId/:tab(interfaces|routes)/:action(add)',
    name: 'iframeRouterInterfacesAdd',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeVirtualRouterInterface'),
  },
  {
    path: 'routers/:routerId/:tab(interfaces|routes)/:itemId/:action(edit)',
    name: 'iframeRouterInterfacesEdit',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeVirtualRouterInterface'),
  },
  {
    path: 'vpn/add',
    name: 'vpnCreate',
    component: () => import('@/self-service/pages/iframe/iframeVpnAdd'),
    meta: {
      title: $t => $t('VPN'),
      restrictions: {
        action: 'read',
        resource: 'compute_vpn_ipsec_site_connections'
      },
    }
  },
  {
    path: 'vpn/:vpnId/edit/',
    name: 'vpnEdit',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeVpnEdit'),
    meta: {
      title: $t => $t('Edit VPN'),
      restrictions: {
        action: 'update',
        resource: 'compute_vpn_ipsec_site_connection'
      },
    }
  },
  {
    path: 'load-balancers/add',
    name: 'iframeLoadBalancerAdd',
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerAdd'),
    meta: {
      title: $t => $t('Create load balancer'),
      restrictions: {
        action: 'create',
        resource: 'compute_load_balancers'
      },
    },
    children: [
      {
        path: 'add-pool',
        name: 'iframeLoadBalancerAddPool',
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersAddPool'),
        meta: {
          title: $t => $t('Create load balancer pool'),
          restrictions: {
            action: 'create',
            resource: 'compute_load_balancing_pools'
          },
        },
        children: [
          {
            path: 'vms',
            name: 'iframeLoadBalancersPoolVms',
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersPoolVms'),
            meta: {
              title: $t => $t('Edit load balancer pool members'),
              restrictions: {
                action: 'create',
                resource: 'compute_load_balancing_pool_members'
              },
            },
          },
          {
            path: 'healthmonitor',
            name: 'iframeLoadBalancersPoolMonitorParams',
            component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersMonitorParams'),
            meta: {
              title: $t => $t('Edit health monitor')
            },
          }
        ]
      }
    ]
  },
  {
    path: 'load-balancers/:loadBalancerId/edit',
    name: 'iframeLoadBalancerEdit',
    props: true,
    meta: {
      title: $t => $t('Edit load balancer pool'),
      restrictions: {
        action: 'update',
        resource: 'compute_load_balancer'
      },
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerEdit'),
  },
  {
    path: 'load-balancers/:loadBalancerId/add-pool',
    name: 'iframeLoadBalancersAddPool',
    props: true,
    meta: {
      title: $t => $t('Create load balancer pool'),
      restrictions: {
        action: 'create',
        resource: 'compute_load_balancing_pools'
      },
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerAddPool'),
    children: [
      {
        path: 'vms',
        name: 'iframeLoadBalancersPoolVms',
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersPoolVms'),
        meta: {
          title: $t => $t('Edit load balancer pool members'),
          restrictions: {
            action: 'create',
            resource: 'compute_load_balancing_pool_members'
          },
        },
      },
      {
        path: 'healthmonitor',
        name: 'iframeLoadBalancersPoolMonitorParams',
        component: () => import('@/self-service/pages/compute/loadBalancers/loadBalancersMonitorParams'),
      }
    ]
  },
  {
    path: 'load-balancers/:loadBalancerId/edit-pool/:loadBalancerPoolId',
    name: 'iframeLoadBalancerPoolEdit',
    props: true,
    meta: {
      title: $t => $t('Edit load balancer pool'),
      restrictions: {
        action: 'update',
        resource: 'compute_load_balancing_pool'
      }
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerPoolEdit'),
  },
  {
    path: 'load-balancers/:loadBalancerId/edit-pool/:loadBalancerPoolId/members',
    name: 'iframeLoadBalancerPoolEditVms',
    props: true,
    meta: {
      title: $t => $t('Edit load balancer pool members'),
      restrictions: {
        action: 'update',
        resource: 'compute_load_balancing_pool_member'
      },
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerPoolEditVms'),
  },
  {
    path: 'load-balancers/:loadBalancerId/edit-pool/:loadBalancerPoolId/allowed-cidrs',
    name: 'iframeLoadBalancerPoolEditAllowedCidrs',
    props: true,
    meta: {
      title: $t => $t('Edit allowed CIDRs')
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerPoolEditAllowedCidrs'),
  },
  {
    path: 'load-balancers/:loadBalancerId/edit-pool/:loadBalancerPoolId/health',
    name: 'iframeLoadBalancerPoolEditHealth',
    props: true,
    meta: {
      title: $t => $t('Edit health monitor')
    },
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerPoolEditHealth'),
  },
  {
    path: 'load-balancers/:loadBalancerId/details',
    name: 'iframeLoadBalancerChart',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerChart.vue'),
  },
  {
    path: 'load-balancers/:loadBalancerId/pool/:loadBalancerPoolId/details',
    name: 'iframeLoadBalancerPoolChart',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeLoadBalancerPoolChart.vue'),
  },
  {
    path: 'backup-plans/add',
    name: 'iframeBackupPlanAdd',
    component: () => import('@/self-service/pages/iframe/iframeBackupPlanAdd'),
  },
  {
    path: 'backup-plans/:id/edit',
    name: 'iframeBackupPlanEdit',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeBackupPlanAdd'),
  },
  {
    path: 'security-groups/add',
    name: 'iframeSecurityGroupAdd',
    component: () => import('@/self-service/pages/iframe/iframeSecurityGroupAdd'),
    meta: {
      restrictions: {
        action: 'create',
        resource: 'compute_security_groups'
      },
      title: $t => $t('Create security group')
    },
  },
  {
    path: 'security-groups/:groupId/edit',
    name: 'iframeSecurityGroupEdit',
    props: true,
    meta: {
      restrictions: {
        action: 'update',
        resource: 'compute_security_group'
      },
      title: $t => $t('Edit security group')
    },
    component: () => import('@/self-service/pages/iframe/iframeSecurityGroupAdd'),
  },
  {
    path: 'security-groups/:groupId/rules',
    name: 'iframeSecurityGroupRules',
    props: true,
    component: () => import('@/self-service/pages/iframe/iframeSecurityGroupRules.vue'),
  }
];

export default list;
